import { render, staticRenderFns } from "./ElectricityPriceCalculator.vue?vue&type=template&id=08d9d49d"
import script from "./ElectricityPriceCalculator.vue?vue&type=script&lang=ts"
export * from "./ElectricityPriceCalculator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports